const TAGE = ["Mo", "Di", "Mi", "Do", "Fr", "Sa"];
const ZEITEN = ["Vormittag", "Nachmittag", "Abend"];

const Chip = ({ val, on, onToggle }) => (
    <button
        type="button"
        data-testid={`kontakt-chip-${val.toLowerCase()}`}
        aria-pressed={on}
        onClick={() => onToggle(val)}
        className={`font-sans text-[12px] tracking-[0.08em] px-4 py-2 border transition-colors duration-200 ${
            on ? "bg-[#2B2825] border-[#2B2825] text-[#FAF8F5]" : "bg-transparent border-[#C8C0B0] text-[#59534C] hover:border-[#2B2825]"
        }`}
    >
        {val}
    </button>
);

export const ErreichbarkeitPicker = ({ value, onChange, labelCls }) => {
    const toggle = (val) => onChange(value.includes(val) ? value.filter((v) => v !== val) : [...value, val]);
    return (
        <div className="mt-7" data-testid="kontakt-erreichbarkeit">
            <p className={labelCls}>
                Wann bist du am besten erreichbar? <span className="normal-case tracking-normal">(optional)</span>
            </p>
            <div className="mt-3 flex flex-wrap gap-2">
                {TAGE.map((t) => <Chip key={t} val={t} on={value.includes(t)} onToggle={toggle} />)}
            </div>
            <div className="mt-2.5 flex flex-wrap gap-2">
                {ZEITEN.map((z) => <Chip key={z} val={z} on={value.includes(z)} onToggle={toggle} />)}
            </div>
        </div>
    );
};
